import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import { DataTable, HelperViewContextual } from '@warrenbrasil/nebraska-web';
import { columns } from './columns';
import { CustomOperationPosition } from '@/modules/trade/services/instruments/types';

interface Props {
  isLoading: boolean;
  itemsPerPage: number;
  items: CustomOperationPosition[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomOperationsTable',
  props: {
    isLoading: { type: Boolean },
    itemsPerPage: null,
    items: null
  },
  setup(__props: any) {

const props = __props as {
  isLoading: boolean;
  itemsPerPage: number;
  items: CustomOperationPosition[];
};



const router = useRouter();

const status = computed(() => (props.isLoading ? 'loading' : 'default'));

const handleOnRowClick = ({ id }: CustomOperationPosition) => {
  router.push({
    name: 'customOperationDetails',
    params: { id }
  });
};

return { __sfc: true,props, router, status, handleOnRowClick, DataTable, HelperViewContextual, columns }
}

})